import { render, staticRenderFns } from "./AdminPanelNav.vue?vue&type=template&id=023fa75c&scoped=true&"
import script from "./AdminPanelNav.vue?vue&type=script&lang=js&"
export * from "./AdminPanelNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelNav.vue?vue&type=style&index=0&id=023fa75c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fa75c",
  null
  
)

export default component.exports